import http, { getBase } from '../../http'
import authHeader from '../../headers'

const API_URL = 'photo-evidences'

/**
 * Módulo transversal de evidencia fotográfica (socialización / elemento físico).
 * La imagen se sube por multipart al backend (igual que firmas/branding); el backend la
 * redimensiona y la guarda en el bucket. reference_type/reference_id la cuelgan de un
 * registro concreto (entrega EPP, versión de matriz); sin ellos = galería general.
 */
class PhotoEvidenceAPI {

  async getAll({ companyId, itemCode, referenceType = null, referenceId = null }) {
    let q = `companies_id=${companyId}&item_code=${encodeURIComponent(itemCode)}`
    if (referenceType) q += `&reference_type=${encodeURIComponent(referenceType)}`
    if (referenceId !== null && referenceId !== undefined && referenceId !== '') q += `&reference_id=${referenceId}`
    return await http(`${API_URL}?${q}`, 'GET')
  }

  async save({ companyId, itemCode, referenceType, referenceId, category, description, takenAt, file }) {
    const fd = new FormData()
    fd.append('companies_id', companyId)
    fd.append('item_code', itemCode)
    if (referenceType) fd.append('reference_type', referenceType)
    if (referenceId !== null && referenceId !== undefined && referenceId !== '') fd.append('reference_id', referenceId)
    if (category) fd.append('category', category)
    if (description) fd.append('description', description)
    if (takenAt) fd.append('taken_at', takenAt)
    fd.append('image', file)
    const res = await fetch(`${getBase()}${API_URL}/save`, {
      method: 'POST',
      headers: { Accept: 'application/json', ...authHeader() },
      body: fd,
    })
    return res.json()
  }

  async delete(id) {
    return await http(`${API_URL}/delete/${id}`, 'DELETE')
  }
}

export default new PhotoEvidenceAPI()
